(() => {
  const upgrade = () => {
    document.querySelectorAll('a').forEach(link => {
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.parentElement.closest('svg,script,style,.ss-link-arrow') && /↗/.test(node.nodeValue)) nodes.push(node);
      }
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.nodeValue.split(/↗\uFE0F?/).forEach((part, index) => {
          if (index) {
            const badge = document.createElement('span');
            badge.className = 'ss-link-arrow';
            badge.setAttribute('aria-hidden', 'true');
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('focusable', 'false');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'M6 18 18 6M6 6h12v12');
            svg.appendChild(path);
            badge.appendChild(svg);
            fragment.appendChild(badge);
          }
          fragment.appendChild(document.createTextNode(part));
        });
        node.replaceWith(fragment);
        link.classList.add('ss-has-arrow');
      });
    });
  };
  upgrade();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; upgrade(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
